

function log(message, css) {
  console.log('%c' + message, css);   // eslint-disable-line
}

function logColor(message, color) {
  log(message, 'color: ' + color);
}

export function logSsf(message) {
  logColor('[SSF] ' + message, 'blue');
}
